import React from 'react';
import {
  Switch,
  Route,
} from 'react-router-dom';
import config from '@/configs/config';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { Box } from '@material-ui/core';
import List from './containers/List';
import Detail from './containers/Detail';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    minHeight: 'calc(100vh - 100px)',
    padding: 0,
    width: '100%',
    marginTop: theme.spacing(2),
    '@media (min-width: 796px)': {
      maxWidth: '768px',
    },
    '@media (min-width: 976px)': {
      maxWidth: '876px',
      marginTop: theme.spacing(9),
    },
    '@media (min-width: 1180px)': {
      maxWidth: '1080px',
    },
    '@media (min-width: 1440px)': {
      maxWidth: '1340px',
    },
  },
}));

export default () => {
  const classes = useStyles();
  return (
    <Container className={classes.root} maxWidth={false}>
      <Box display={{ xs: 'none', sm: 'block' }} width={186} mr={9} flexShrink={0}>
        <Box fontWeight="bold" px={1} fontSize={18}>常見問與答</Box>
        <Box borderBottom="1px solid rgb(151,151,151)" my={2} />
        <Box px={1}>
          <Box fontSize={14}>
            請在選單中選擇您的問題類型，我們將提供給您合適的解答，希望能幫助到您。
          </Box>
          <Box mt={8} fontSize={14}>
            <Box>找不到人解答嗎?</Box>
            <Box>
              <Box component="span">請連繫</Box>
              {' '}
              <a
                href={config.faqCustomerServiceUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: 'black',
                  textDecoration: 'underline',
                }}
              >
                專人客服
              </a>
              {' '}
              <Box component="span">來為您解答</Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box flexGrow={1}>
        <Switch>
          <Route path="/faq/:id/:childId" component={Detail} />
          <Route path="/faq" component={List} />
        </Switch>
      </Box>
    </Container>
  );
};
